import { useEffect, useState, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthService } from '../../../services/auth.service';

export default function Headers() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    email: '',
    hospitalName: '',
    role: ''
  });

  const detailsRef = useRef(null);

  useEffect(() => {
    const user = AuthService.getUserData();
    if (user) {
      setUserData({
        email: user.email || '',
        hospitalName: user.hospitalName || '',
        role: user.role || ''
      });
    } else {
      navigate('/login');
    }
  }, [navigate]);

  const handleClickOutside = (event) => {
    if (detailsRef.current && !detailsRef.current.contains(event.target)) {
      detailsRef.current.removeAttribute('open');
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleSignOut = () => {
    if (detailsRef.current) {
      detailsRef.current.removeAttribute('open');
    }
    AuthService.clearAuth();
    navigate('/login');
  };

  const handleMenuClick = () => {
    if (detailsRef.current) {
      detailsRef.current.removeAttribute('open');
    }
  };

  return (
    <div className="navbar bg-black fixed top-0 left-0 w-full z-50">
      <div className="flex items-center justify-between w-full px-4">
        <div className="flex items-center">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/cg-ses-files-upload.appspot.com/o/hostingImage%2FCRC_BK_BIG_Black.png?alt=media&token=19509bea-d71a-40a6-95bc-7fcc72c69c6e"
            alt="Logo"
            className="w-44 h-auto"
          />
        </div>
        <div className="dropdown dropdown-end">
          <details ref={detailsRef} className="dropdown">
          <summary className="btn btn-ghost flex items-center space-x-2">
          {/* Avatar */}
          <div className="bg-white text-neutral-700 rounded-full w-12 h-12 font-bold flex items-center justify-center">
            <span>{userData.hospitalName.slice(0, 3).toUpperCase()}</span>
          </div>
          {/* Hospital Name and Email */}
          <div className="flex flex-col items-start">
            <span className="text-sm text-white font-medium">{userData.hospitalName}</span>
            <span className="text-xs text-gray-300">{userData.email}</span>
          </div>
        </summary>
            <ul className="mt-3 z-[1] p-2 shadow menu menu-sm dropdown-content bg-base-100 rounded-box w-52">
              {userData.role === 'systemAdmin' ? (
                <>
                  <li>
                    <Link to="/" onClick={handleMenuClick}>
                      <i className="fa-solid fa-house mr-2 text-gray-500"></i>Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/files" onClick={handleMenuClick}>
                      <i className="fa-solid fa-folder mr-2 text-gray-500"></i>
                      File Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/users" onClick={handleMenuClick}>
                      <i className="fa-solid fa-user-group mr-2 text-gray-500"></i>
                      User Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/hospitals" onClick={handleMenuClick}>
                      <i className="fa-solid fa-truck-medical mr-2 text-gray-500"></i>
                      Hospital Management
                    </Link>
                  </li>
                  <li>
                    <button onClick={handleSignOut} className="text-left w-full">
                      <i className="fa-solid fa-right-from-bracket mr-2 text-gray-500"></i>
                      Sign Out
                    </button>
                  </li>
                </>
              ) : userData.role === 'admin' ? (
                <>
                  <li>
                    <Link to="/" onClick={handleMenuClick}>
                      <i className="fa-solid fa-house mr-2 text-gray-500"></i>Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/files" onClick={handleMenuClick}>
                      <i className="fa-solid fa-folder mr-2 text-gray-500"></i>
                      File Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/users" onClick={handleMenuClick}>
                      <i className="fa-solid fa-user-group mr-2 text-gray-500"></i>
                      User Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/hospitals" onClick={handleMenuClick}>
                      <i className="fa-solid fa-truck-medical mr-2 text-gray-500"></i>
                      Hospital Management
                    </Link>
                  </li>
                  <li>
                    <button onClick={handleSignOut} className="text-left w-full">
                      <i className="fa-solid fa-right-from-bracket mr-2 text-gray-500"></i>
                      Sign Out
                    </button>
                  </li>
                </>
              ) : userData.role === 'user' ? (
                <>
                  <li>
                    <Link to="/" onClick={handleMenuClick}>
                      <i className="fa-solid fa-house mr-2 text-gray-500"></i>Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/files" onClick={handleMenuClick}>
                      <i className="fa-solid fa-folder mr-2 text-gray-500"></i>
                      File Management
                    </Link>
                  </li>
                  <li>
                    <button onClick={handleSignOut} className="text-left w-full">
                      <i className="fa-solid fa-right-from-bracket mr-2 text-gray-500"></i>
                      Sign Out
                    </button>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <Link to="/" onClick={handleMenuClick}>
                      <i className="fa-solid fa-house mr-2 text-gray-500"></i>Home
                    </Link>
                  </li>
                  <li>
                    <button onClick={handleSignOut} className="text-left w-full">
                      <i className="fa-solid fa-right-from-bracket mr-2 text-gray-500"></i>
                      Sign Out
                    </button>
                  </li>
                </>
              )}
            </ul>
          </details>
        </div>
      </div>
    </div>
  );
}